import useBSSLogger from './useBSSLogger';

const {logger} = useBSSLogger();

const useDependencies = ({name, dependsOn, methods}) => {
    
    const {watch, setValue} = methods;

    let dipendenze = [];
    if(dependsOn !== null){
        logger.debug("watch per", name)
        dipendenze = watch(dependsOn);

        

        watch((data, {name: depname, type}) => {
            if(dependsOn.includes(depname) && type === 'change'){
                const newval = data[depname];
                if(newval === null){
                    setValue(name, null);
                }
            }
        })
    }    
    const disabilitaByDep = dipendenze.filter(d => d === null).length > 0
    

    return {dipendenze, disabilitaByDep}
}


export default useDependencies;

